module.exports = __webpack_public_path__ + "static/img/top.276a375.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/top.jpg
 ** module id = 588
 ** module chunks = 2
 **/